import { axios } from '../../../plugins/axios'

export default {
  namespaced: true,

  state: {
    reactivoPrincipio: [],
  },

  getters: {
    getReactivoPrincipio: (state) => {
      return state.reactivoPrincipio
    },
  },

  mutations: {
    SET_REACTIVO_PRINCIPIO(state, reactivoPrincipio) {
      state.reactivoPrincipio = reactivoPrincipio
    },
  },

  actions: {
    fetchReactivoPrincipio: async function ({ commit }) {
      await axios
        .get('/PoliciaCuadrantes/DesarrolloPolicial/reactivoPrincipio')
        .then((response) => {
          commit('SET_REACTIVO_PRINCIPIO', response.data.data)
        })
        .catch((error) => console.log(error))
    },
  },
}
